module.exports = __webpack_public_path__ + "static/media/MkAesthetics.29deff68.png";